import { useCallback } from "react";
import * as React from "react";
import { ListItemIcon, MenuItem } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { useLogout } from "ra-core";
import ExitIcon from "@material-ui/icons/PowerSettingsNew";

const useStyles = makeStyles((theme: Theme) => ({
  menuItem: {
    color: theme.palette.text.secondary,
  },
  icon: { minWidth: theme.spacing(5) },
}));

const CustomLogoutButton = () => {
  const classes = useStyles();
  const logout = useLogout();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleClick = useCallback(() => logout(null, "/", false), [logout]);

  return (
    <MenuItem className={classes.menuItem} onClick={handleClick}>
      <ListItemIcon className={classes.icon}>
        <ExitIcon />
      </ListItemIcon>
      Logout
    </MenuItem>
  );
};

export default CustomLogoutButton;
